
export const name = "setup-guide-ui";
export const version = "dev";
